export const IFRAME_MIN_WIDTH = 300;
export const IFRAME_MAX_WIDTH = 600;
export const TIMEOUT_VALUE = 500;
export const IFRAME_EXTRA_PADDING = 30;
export const IFRAME_RATIO = 1.22;
export const COMPARE_BUTTON_HEIGHT = 225;
export const SKIN_SMOOTH_STRENGTH = 50;
export const PIE_CHART_DEFAULT_VALUE = 1;
export const CUSTOM_SLIDES_TO_SHOW = 5;
export const CUSTOM_SLIDES_TO_SCROLL = 5;
export const VTO_GUID = 'guid';
export const NO_SCROLL_CLASS = 'no-scroll';
export const VTO_ACTIVE_CLASS = 'vto-active';
export const VTO_DISCLOSE_PARAM = 'vto_disclose';
export const VTO_OPEN_PARAM = 'vto_open';
export const VTO_MATCHES_COOKIE_NAME = 'vtoMatches';

export enum Events {
    CAMERA_CLOSED = 'cameraClosed',
    CAMERA_FAILED = 'cameraFailed',
    CAMERA_OPENED = 'cameraOpened',
    COMPARE = 'compare',
    COMPARE_DISABLED = 'compareDisabled',
    CLOSED = 'closed',
    ENGINE_CLOSED = 'engineClosed',
    LOADED = 'loaded',
    LOADING = 'loading',
    KISS_DETECTED = 'kissDetected',
    OPENED = 'opened',
    PHOTO_LOADED = 'photoLoaded',
    PHOTO_SAVED = 'photoSaved',
    RESET = 'reset',
    VIDEO_LOADED = 'videoLoaded',
    SHADE_FINDER_STARTED = 'shadeFinderStarted',
    SHADE_FINDER_COMPLETED = 'shadeFinderCompleted',
    SHADE_FINDER_CANCELLED = 'shadeFinderCancelled',
    SKIN_SHADE_FOUND = 'skinShadeFound',
    ZOOM = 'zoom'
}

export enum FoundationShadeTypes {
    COOLER = 'cooler',
    LIGHTER = 'lighter',
    BEST = 'best',
    DARKER = 'darker',
    WARMER = 'warmer'
}

export enum FoundationPairShadeTypes {
    CASUAL = 'casualPair',
    BEST = 'bestPair',
    GLAM = 'glamPair'
}
